import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, throwError, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { ContentService } from 'src/app/shared/services/content.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable({
  providedIn: 'root'
})
export class UserManagementServiceService {
  userManagementEndPoint = '';
  private isProfiledBehavior = new BehaviorSubject<boolean>(false);
    isProfiled = this.isProfiledBehavior.asObservable();
    public isProfile: any = new BehaviorSubject('false');
  constructor(private httpClient: HttpClient, private contentService: ContentService, private snackBar: MatSnackBar, ) { }
  getToken(): string {
    return sessionStorage.getItem('token') || '';
  }

  setHeaders(): { headers: HttpHeaders } {
  const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': sessionStorage.getItem('token') || ''
  });
  return { headers };
  }

  setHeadersJwt(): { headers: HttpHeaders } {
    const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'x-access-token': sessionStorage.getItem('token') || '',
        'x-jwt-token': sessionStorage.getItem('jwtToken') || ''
    });
    return { headers };
    }
  countryDetails(countryId: number = 0): Observable<any>{
    const filter = countryId > 0 ? '?id=' + countryId : '';
    return this.httpClient.get(environment.baseURL + 'country/list' + filter, this.setHeaders()).pipe(map((response: any) => response))
    .pipe(
      catchError(this.handlehttpError)
    );
  }
  sectorNameDetails(selectedCountryId: any = ''): Observable<any> {
    return this.httpClient
    .get(environment.baseURL + 'sector/list?country_id=' + selectedCountryId, this.setHeaders()).pipe(map((response: any) => response))
    .pipe(
      catchError(this.handlehttpError)
    );

  }
  msmeNameDetails(id: string = ''): Observable<any> {
    return this.httpClient.get(environment.baseURL + 'msme/list?sector_id=' + id, this.setHeaders()).pipe(map((response: any) => response))
    .pipe(
      catchError(this.handlehttpError)
    );
  }
  UserRoleDetails(id: number = 0): Observable<any> {
    const endPoint = `role/list?isUserMgmt=true&fetched=all`;
    return this.httpClient.get(environment.baseURL + endPoint, this.setHeaders()).pipe(map((response: any) => response))
    .pipe(
      catchError(this.handlehttpError)
    );
  }
  createUser(userPayload: any): Observable<any> {
    return this.httpClient
    .post(environment.baseURL + 'user/create', (userPayload), this.setHeadersJwt()).pipe(map((response: any) => response))
    .pipe(
      catchError(this.handlehttpError)
    );
}
getUserDataById(id: string): Observable<any> {
  return this.httpClient.get(environment.baseURL + 'user/list' + `?id=${id}`, this.setHeaders()).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}
getUserPermission(): Observable<any> {
  return this.httpClient.get(environment.baseURL + 'authenication/list' , this.setHeaders()).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}
createRole(userPayload: any): Observable<any> {
  return this.httpClient
  .post(environment.baseURL + 'authenication/create', JSON.stringify(userPayload), this.setHeaders()).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}
  allUserDetails(page = 1, limit = 10, sortingOrder: string = '', columnName: string = ''): Observable<any> {
    if (['DESC', 'ASC'].includes(sortingOrder)) {
      return this.httpClient.get(
        environment.baseURL + 'user/list' +
        `?isUserMgmt=true&limit=${limit}&page=${page}&key=${columnName}&order=${sortingOrder}`,
        this.setHeaders()
      ).pipe(map((response: any) => response))
        .pipe(
          catchError(this.handlehttpError)
        );
    }
    else {
      return this.httpClient.get(
        environment.baseURL + 'user/list' + `?isUserMgmt=true&limit=${limit}&page=${page}`,
        this.setHeaders()
      ).pipe(map((response: any) => response))
        .pipe(
          catchError(this.handlehttpError)
        );
    }
  }
updateUserRole(data: any, id: string): Observable<any> {
  return this.httpClient
  .post(environment.baseURL + 'authenication/update/' + id, JSON.stringify(data), this.setHeaders()).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}
deleteRole(id: string, payload: any): Observable<any> {
  return this.httpClient
  .post(
    environment.baseURL + 'authenication/update/' + id,
    JSON.stringify(payload),
    this.setHeaders()
  ).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}
deleteByUserId(id: string, payload: any): Observable<any> {
  return this.httpClient.put(environment.baseURL + 'user/update/' + id, payload, this.setHeaders()).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}
updateUser(id: string, data: any): Observable<any> {
  return this.httpClient
  .put(environment.baseURL + 'user/update/' + id, JSON.stringify(data), this.setHeaders()).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}
serachData(searchString: string, endPoint: string): Observable<any> {
  return this.httpClient
  .get(
    environment.baseURL + `${endPoint}?isUserMgmt=true&searchKey=${searchString}&fetched=all`,
    this.setHeaders()
  ).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}
allRoleDetails(page= 1, limit= 10, sortingOrder: string = '', columnName: string = ''): Observable<any> {
  if (['DESC', 'ASC'].includes(sortingOrder)) {
    return this.httpClient.get(
      environment.baseURL + 'authenication/view' +
      `?isUserMgmt=true&limit=${limit}&page=${page}&order=${sortingOrder}&key=${columnName}`,
      this.setHeaders()
    ).pipe(map((response: any) => response))
    .pipe(
      catchError(this.handlehttpError)
    );
  }
  else{
    return this.httpClient.get(
      environment.baseURL + 'authenication/view' + `?isUserMgmt=true&limit=${limit}&page=${page}`,
      this.setHeaders()
    ).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
  }

}
getRoleDataById(id: string): Observable<any> {
  return this.httpClient
  .get(environment.baseURL + 'authenication/view' + `?role_id=${id}`, this.setHeaders()).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}
  handlehttpError(request: HttpErrorResponse): any {
    return throwError(request.error ? request.error : request.message ? request.message : 'SERVER ERROR');
}
actionTablePermission(actionArray: any[], permissionArray: any): any[] {
  return actionArray.map((mainItem: any) => {
    permissionArray?.authentication?.forEach((secondaryItem: any) => {
      if (mainItem.key === secondaryItem.key){
        mainItem.isPermission = secondaryItem.isAction;
      }
    });
    return mainItem; // Return the updated mainItem
  });
}
getProfileDetailsById(id: string): Observable<any> {
  return this.httpClient.get(environment.baseURL + 'user/view' + `?id=${id}`, this.setHeaders()).pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}

targettedUserData(body: any): Observable<any>{
  return this.httpClient.post(environment.baseURL + `ipsa/create`, body);
}

updateUserForIpsa(body: any): Observable<any>{
  return this.httpClient.post(environment.baseURL + `ipsa/create`, body);
}

ipsaReportList(filterParams: any = ''): Observable<any>{
  return this.httpClient
  .get(environment.baseURL + 'ipsa/submissionlist' + filterParams, this.setHeaders())
  .pipe(map((response: any) => response))
  .pipe(
    catchError(this.handlehttpError)
  );
}

  ipsaReportDownload(payload: any, item: any): void {
    this.contentService?.loaderSubscriber?.next(true);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', environment.baseURL + 'ipsa/report', true);
    xhr.setRequestHeader('x-access-token', sessionStorage.getItem('token') || '');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
    xhr.responseType = 'blob';
    const self = this;
    xhr.onload = function(this: XMLHttpRequest, event: Event): void {
      if (this.status === 200) {
        const blob = this.response;
        let fileName: string = item?.year + '_' + item?.country_name + '_' + item?.sector_name;
        fileName += item?.msme_name ? '_' + item?.msme_name + '.pdf' : '.pdf';
        saveAs(blob, fileName);
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          const errorText = reader.result as string;
          const errorJson = JSON.parse(errorText);
          const errorMessage = errorJson.message || 'An error occurred.';
          self.snackBar.open(errorMessage, '', {
            duration: 3000,
            panelClass: ['primary']
          });
        };
        reader.readAsText(this.response);
      }

      self.contentService?.loaderSubscriber?.next(false);
    };
    xhr.send(payload);
  }

  getMasterLevel(): Observable<any> {
    return this.httpClient
    .get(environment.baseURL + 'userlevel/list?isUserMgmt=true' , this.setHeaders()).pipe(map((response: any) => response))
    .pipe(
      catchError(this.handlehttpError)
    );
  }

  getDashboardModule(): Observable<any> {
    return this.httpClient
    .get(environment.baseURL + `dashboard/authentication/view`, this.setHeaders())
    .pipe(map((response: any) => response))
    .pipe(
      catchError(this.handlehttpError)
    );
  }

  setDashboardModule(userPayload: any): Observable<any> {
    return this.httpClient
    .put(
      environment.baseURL + `dashboard/authentication/update`,
      (userPayload),
      this.setHeadersJwt()
    ).pipe(map((response: any) => response))
    .pipe(
      catchError(this.handlehttpError)
    );
  }

  getInterestsList(
    page = 1, limit = 10, order = '', columnName = '', companyName = '',
    status = '', countryId = '', sectorId = ''
  ): Observable<any> {
    let params = `?page=${page}&limit=${limit}`;
    if (order && columnName) { params += `&order=${order}&key=${columnName}`; }
    if (companyName) { params += `&company_name=${encodeURIComponent(companyName)}`; }
    if (status) { params += `&status=${status}`; }
    if (countryId) { params += `&country_id=${countryId}`; }
    if (sectorId) { params += `&sector_id=${sectorId}`; }
    return this.httpClient
      .get(environment.baseURL + 'interests/list' + params, this.setHeaders())
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handlehttpError));
  }

  approveInterest(id: string): Observable<any> {
    return this.httpClient
      .post(environment.baseURL + 'interests/approve/' + id, {}, this.setHeaders()).pipe(map((response: any) => response))
      .pipe(catchError(this.handlehttpError));
  }

  rejectInterest(id: string, body?: { decline_reason?: string }): Observable<any> {
    return this.httpClient
      .post(environment.baseURL + 'interests/reject/' + id, body || {}, this.setHeaders()).pipe(map((response: any) => response))
      .pipe(catchError(this.handlehttpError));
  }

}
